import Vue from 'vue'
import Router from 'vue-router'

import axios from 'axios'
import VueAxios from 'vue-axios'

// Containers
import Full from '@/containers/Full'

// Views
import Login from '@/views/Login2'
import Home from '@/views/Home'

import Calendar from '@/views/Calendar/Calendar'

import ClientSide from '@/views/ClientSide/Result'
import Registration from '@/views/Registration/Registration'
import RegistrationClient from '@/views/Registration/components/RegistrationClient'
import RegistrationClientInsurance from '@/views/Registration/components/RegistrationClientInsurance'
import RegistrationClientEmail from '@/views/Registration/components/RegistrationClientEmail'
import RegistrationClientPhone from '@/views/Registration/components/RegistrationClientPhone'
import RegistrationClientAddress from '@/views/Registration/components/RegistrationClientAddress'

import AddAddress from '@/views/Client/AddAddress'
import AddContact from '@/views/Client/AddContact'
import ShowClient from '@/views/Client/ShowClient'

import ShowVisit from '@/views/Visit/ShowVisit'
import VisitDiagnosis from '@/views/Visit/components/VisitDiagnosis'
import VisitMedicalReport from '@/views/Visit/components/VisitMedicalReport'
import VisitMedicament from '@/views/Visit/components/VisitMedicament'
import VisitVoucher from '@/views/Visit/components/VisitVoucher'
import DocumentComponent from '@/views/Document/DocumentComponent'

import Setting from '@/views/Setting/Setting'

import AddVisit from '@/views/Client/components/AddVisit'
import ClientVisit from '@/views/Client/components/ClientVisit'
import ClientAnamnesis from '@/views/Client/components/ClientAnamnesis'
import ClientResult from '@/views/Client/components/ClientResult'
import ClientMessage from '@/views/Client/components/ClientMessage'
import ClientMedicament from '@/views/Client/components/ClientMedicament'
import ClientMedicalReport from '@/views/Client/components/ClientMedicalReport'
import ClientTask from '@/views/Client/components/ClientTask'

import HomeReceptionist from '@/views/HomeReceptionist/HomeReceptionist'
import HomeDoctor from '@/views/HomeDoctor/HomeDoctor'

import Reporting from '@/views/Reporting/Reporting'

import Statistic from '@/views/Statistic/Statistic'

import Result from '@/views/Result/Result'
import ContractualReporting from '@/views/ContractualReporting/ContractualReporting'
import Task from '@/views/Task/Task'

import Settings from '../variables'
import { syncStaffSession } from '@/services/staff-session'

Vue.use(Router)

axios.defaults.baseURL = Settings.hostname.replace(/\/$/, '') // Remove trailing slash
axios.defaults.withCredentials = true

Vue.use(VueAxios, axios)

Vue.router = new Router()

const router = new Router({
  // mode: 'history',
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/cs',
      name: 'ClientSide',
      component: ClientSide,
      meta: {label: 'dokument klienta'}
    },
    {
      path: '/',
      redirect: '/home',
      // name: 'Home',
      component: Full,
      meta: {label: 'Domů'},
      children: [
        /* {
          path: 'login',
          name: 'Login',
          component: Login
        }, */
        {
          path: 'home',
          name: 'Home',
          component: Home,
          meta: {auth: true, role: '', label: 'Přehled návštěv'}
        },
        {
          path: 'calendar',
          name: 'Calendar',
          component: Calendar,
          meta: {auth: true, role: '', label: 'Kalendář'}
        },
        {
          path: 'result',
          name: 'Result',
          component: Result,
          meta: {auth: true, role: '', label: 'Laboratorní výsledky'}
        },
        {
          path: 'contractual-reporting',
          name: 'ContractualReporting',
          component: ContractualReporting,
          meta: {auth: true, role: '', label: 'Výkaz dávek'}
        },
        {
          path: 'task',
          name: 'Task',
          component: Task,
          meta: {auth: true, role: '', label: 'Úkoly'}
        },
        {
          path: 'registration',
          name: 'ClientRegistration',
          component: Registration,
          meta: {step: 1, label: 'Registrace klienta'},
          children: [
            {
              path: '',
              component: RegistrationClient,
              name: 'RegistrationClient',
              meta: {step: 1, label: 'Základní údaje'}
            },
            {
              path: ':clientid/insurance',
              component: RegistrationClientInsurance,
              name: 'RegistrationClientSelectInsurance',
              meta: {step: 2, label: 'Výběr zdravotní pojištovny'}
            },
            {
              path: ':clientid/email',
              component: RegistrationClientEmail,
              name: 'RegistrationClientSelectEmail',
              meta: {step: 3, label: 'Přidání e-mailů'}
            },
            {
              path: ':clientid/phone',
              component: RegistrationClientPhone,
              name: 'RegistrationClientSelectPhone',
              meta: {step: 4, label: 'Přidání telefonních čísel'}
            },
            {
              path: ':clientid/address',
              component: RegistrationClientAddress,
              name: 'RegistrationClientSelectAddress',
              meta: {step: 5, label: 'Přidání trvalého bydliště'}
            }
          ]
        },
        {
          path: 'client/:clientid/addaddress',
          name: 'AddAddress',
          component: AddAddress,
          meta: {auth: true, role: '', label: 'Přidání adresy'}
        },
        {
          path: 'client/:clientid/addcontact',
          name: 'AddContact',
          component: AddContact,
          meta: {auth: true, role: '', label: 'Přidání kontaktu'}
        },
        {
          path: 'client/:clientid',
          name: 'ShowClient',
          component: ShowClient,
          redirect: 'client/:clientid/visits',
          meta: {auth: true, role: '', label: 'Klient'},
          children: [
            {
              path: 'visits',
              component: ClientVisit,
              name: 'ClientVisit',
              meta: {label: 'Návštěvy'}
            },
            {
              path: 'medicament',
              component: ClientMedicament,
              name: 'ClientMedicament',
              meta: {label: 'Léky'}
            },
            {
              path: 'message',
              component: ClientMessage,
              name: 'ClientMessage',
              meta: {label: 'Zprávy'}
            },
            {
              path: 'medical_report',
              component: ClientMedicalReport,
              name: 'ClientMedicalReport',
              meta: {label: 'Lékařské zprávy'}
            },
            {
              path: 'anamnesis',
              component: ClientAnamnesis,
              name: 'ClientAnamnesis',
              meta: {label: 'Anamnéza'}
            },
            {
              path: 'result',
              component: ClientResult,
              name: 'ClientResult',
              meta: {label: 'Laboratorní výsledky'}
            },
            {
              path: 'task',
              component: ClientTask,
              name: 'ClientTask',
              meta: {label: 'Úkoly'}
            },
            {
              path: 'document',
              component: DocumentComponent,
              name: 'ClientDocument',
              meta: {label: 'Dokumenty'}
            }
            /*,
            {
              path: 'medicament',
              component: VisitMedicament,
              name: 'VisitMedicament',
              meta: {label: 'Léky'}
            },
            {
              path: 'medicalreport',
              component: VisitMedicalReport,
              name: 'VisitMedicalReport',
              meta: {label: 'Lékařská zpráva'}
            },
            {
              path: 'deocument',
              component: VisitDocument,
              name: 'VisitDocument',
              meta: {label: 'Dokumenty'}
            } */
          ]
        },
        {
          path: 'client/:clientid/visit/:visitid',
          name: 'ShowVisit',
          component: ShowVisit,
          meta: {auth: true, role: '', label: 'Návštěva'},
          children: [
            {
              path: 'diagnosis',
              component: VisitDiagnosis,
              name: 'VisitDiagnosis',
              meta: {label: 'Diagnózy a výkony'}
            },
            {
              path: 'medicament',
              component: VisitMedicament,
              name: 'VisitMedicament',
              meta: {label: 'Léky'}
            },
            {
              path: 'voucher',
              component: VisitVoucher,
              name: 'VisitVoucher',
              meta: {label: 'Poukazy'}
            },
            {
              path: 'medicalreport',
              component: VisitMedicalReport,
              name: 'VisitMedicalReport',
              meta: {label: 'Lékařská zpráva'}
            },
            {
              path: 'document',
              component: DocumentComponent,
              name: 'VisitDocument',
              meta: {label: 'Dokumenty'}
            }
          ]
        },
        {
          path: 'client/:clientid/addvisit',
          name: 'AddVisit',
          component: AddVisit,
          meta: {auth: true, role: '', label: 'Přidání návštěvy'}
        },
        {
          path: 'reception',
          name: 'HomeReceptionist',
          component: HomeReceptionist
        },
        {
          path: 'doctor/:doctorid',
          name: 'HomeDoctor',
          component: HomeDoctor
        },
        {
          path: 'setting',
          name: 'Setting',
          component: Setting
        },
        {
          path: 'reporting',
          name: 'Reporting',
          component: Reporting
        },
        {
          path: 'statistic',
          name: 'Statistic',
          component: Statistic
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = 'clinico'
  if (to.name === 'ClientSide') {
    next()
    return
  }

  if (to.name === 'Login') {
    if (Vue.ls.get('authenticated')) next({name: 'Home'})
    else next()
    return
  }

  // The API cookie is authoritative. This one boot-time probe also refreshes the
  // legacy local-storage identity after the Vue 3 app starts impersonation.
  syncStaffSession().then(authenticated => {
    if (authenticated) next()
    else next({name: 'Login'})
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js